// Get the CSS in this joint
import '../styles/main.scss';
import bootstrap from 'bootstrap';
import { isPage } from './vanilla/utils';

// Vanilla JS
import DropdownMenu from './vanilla/dropdown-menu';
import MenuToggle from './vanilla/menu-toggle';
import SearchModal from './vanilla/search-modal';
import SocialLinks from './vanilla/social-links';
import Toggles from './vanilla/toggles';
import InvasiveSpecies from './pages/invasive-species';
import linkBoxes from './vanilla/linkBoxes';
import countdown from './vanilla/countdown.min';
import  './vanilla/gravity-forms-other-button'; // Import your Gravity Forms logic
import HomepageStoryFilter from './jquery/homepage-story-filter';
import successStatistics from './vanilla/successStatistics';


// React Components

document.addEventListener('DOMContentLoaded', function() {





    DropdownMenu.init();
    MenuToggle.init();
    SearchModal.init();
    Toggles.init();
    SocialLinks.init();

    // Homepage stuff
    HomepageStoryFilter.init();
    successStatistics.init();



    if (isPage('invasive-species')) {
        InvasiveSpecies.init();
    }

    if (isPage('run')) {
        countdown.init();       
    }



    


});

// WEBPACK FOOTER //
// ./src/js/main.js


// WEBPACK FOOTER //
// ./src/js/main.js